module.exports = __webpack_public_path__ + "img/group.64f19401.svg";